import React, { ReactNode, createContext, useContext } from 'react';

interface BriefFormContextProps {
    briefId?: string;
    isUploadAndGo?: boolean;
}

const BriefFormContext = createContext<BriefFormContextProps>({});

interface BriefFormProviderProps {
    children: ReactNode;
    briefId?: string;
    isUploadAndGo?: boolean;
}

export const BriefFormProvider: React.FC<BriefFormProviderProps> = ({
    children,
    briefId,
    isUploadAndGo,
}) => {
    return (
        <BriefFormContext.Provider value={{ briefId, isUploadAndGo }}>
            {children}
        </BriefFormContext.Provider>
    );
};

export const useBriefFormContext = () => {
    return useContext(BriefFormContext);
};
